/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dirty_Every_Shrike_LoopInputs */

const fr_dirty_every_shrike_loop = /** @type {(inputs: Dirty_Every_Shrike_LoopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère les roles de l'utilisateur en lui assignant/retirant des rôles`)
};

/**

* @param {Dirty_Every_Shrike_LoopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dirty_every_shrike_loop = /** @type {((inputs?: Dirty_Every_Shrike_LoopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dirty_Every_Shrike_LoopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dirty_every_shrike_loop(inputs)
});